import { ProfileFontSet } from "@authory-packages/core";

const getHeadingLabel = (name: string) => `${name} headings`;
const getParagraphLabel = (name: string) => `${name} paragraphs`;

export const CUSTOM_FONT_SET_SIZES = [ProfileFontSet.OswarldAndQuatroccento, ProfileFontSet.PlayfairSourceSerifPro, ProfileFontSet.RobotoSlabRoboto];

export const getFontSetWeight = (style: ProfileFontSet) => {
    switch (style) {
        case ProfileFontSet.InterAndLora:
            return { headingLabel: 600, paragraphLabel: 400 };
        case ProfileFontSet.OswarldAndQuatroccento:
            return { headingLabel: 500, paragraphLabel: 400 };
        case ProfileFontSet.RobotoAndSpectral:
            return { headingLabel: 700, paragraphLabel: 400 };
        default:
            return { headingLabel: 500, paragraphLabel: 400 };
    }
};

export const getFontSetLabels = (style: ProfileFontSet) => {
    switch (style) {
        case ProfileFontSet.InterAndLora:
            return { headingLabel: getHeadingLabel("Inter"), paragraphLabel: getParagraphLabel("Lora") };
        case ProfileFontSet.RobotoAndSpectral:
            return { headingLabel: getHeadingLabel("Mono"), paragraphLabel: getParagraphLabel("Spectral") };
        case ProfileFontSet.RobotoSlabRoboto:
            return { headingLabel: getHeadingLabel("Slab"), paragraphLabel: getParagraphLabel("Roboto") };
        case ProfileFontSet.LibreSourceSansPro:
            return { headingLabel: getHeadingLabel("Libre"), paragraphLabel: getParagraphLabel("SourceSansPro") };
        case ProfileFontSet.OswarldAndQuatroccento:
            return { headingLabel: getHeadingLabel("Oswald"), paragraphLabel: getParagraphLabel("Quattrocento") };
        case ProfileFontSet.PoppinsNunito:
            return { headingLabel: getHeadingLabel("Poppins"), paragraphLabel: getParagraphLabel("Nunito") };
        case ProfileFontSet.PlayfairSourceSerifPro:
            return { headingLabel: getHeadingLabel("Playfair Display"), paragraphLabel: getParagraphLabel("Source Serif Pro") };
        default:
            return { headingLabel: getHeadingLabel("Inter"), paragraphLabel: getParagraphLabel("Lora") };
    }
};

export const getFontSetNames = (style: ProfileFontSet) => {
    switch (style) {
        case ProfileFontSet.InterAndLora:
            return { headingLabel: "Inter", paragraphLabel: "Lora" };
        case ProfileFontSet.RobotoAndSpectral:
            return { headingLabel: "RobotoMono", paragraphLabel: "Spectral" };
        case ProfileFontSet.RobotoSlabRoboto:
            return { headingLabel: "RobotoSlab", paragraphLabel: "Roboto" };
        case ProfileFontSet.LibreSourceSansPro:
            return { headingLabel: "LibreBaskerville", paragraphLabel: "SourceSans3" };
        case ProfileFontSet.OswarldAndQuatroccento:
            return { headingLabel: "Oswald", paragraphLabel: "Quattrocento" };
        case ProfileFontSet.PoppinsNunito:
            return { headingLabel: "Poppins", paragraphLabel: "Nunito" };
        case ProfileFontSet.PlayfairSourceSerifPro:
            return { headingLabel: "PlayfairDisplay", paragraphLabel: "SourceSerif4" };
        default:
            return { headingLabel: "Inter", paragraphLabel: "Lora" };
    }
};
